<div class="modal-backdrop-custom" (click)="modal.close()">
	<div class="modal-card">
		<i class="bi bi-x bi-lg fs-4 ms-auto pointer" style="position: relative;right: -40%;top:-20px" (click)="modal.close()"></i>

		<div class="modal-icon" style="background: #FEE4E2; border: none;">
			<i class="bi bi-exclamation-circle" style="color: #D92D20; font-size: 28px;"></i>
		</div>
		<div class="modal-title" translate>{{title}}</div>
		<div class="modal-subtitle" translate>{{message}}</div>
	</div>
</div>
